'use strict';

module.exports = require('./Link');